import { useQuery } from "@tanstack/react-query";
import { getCategory } from "../../api/apiCategories";

const useGetCategory = (id) => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["category", id],
        queryFn: () => getCategory(id),
        enabled: !!id,
    });

    return {
        category: data?.data || null,
        error,
        isLoading,
    };
};

export default useGetCategory;
